// Utilitaires partagés du journal système : libellés lisibles des pages et
// reconstruction de l'URL exacte d'une page en erreur.

/** Chemin technique → libellé lisible (Dashboard › Apps › Zstudio). */
export function prettyPage(page: string | null | undefined): string {
  if (!page || page === '/') return 'Accueil public';
  const parts = page.replace(/\/+$/, '').split('/').filter(Boolean);
  if (parts.length === 0) return 'Accueil public';
  return parts
    .map((p) => p.replace(/-/g, ' ').replace(/^\w/, (c) => c.toUpperCase()))
    .join(' › ');
}

function appBase(): string {
  try {
    const base = typeof __BASE_PATH__ === 'string' ? __BASE_PATH__ : '';
    return base.replace(/\/+$/, '');
  } catch {
    return '';
  }
}

/**
 * URL complète de la page en erreur.
 * On privilégie l'URL réellement enregistrée (elle contient les paramètres,
 * donc l'état exact au moment du plantage), à condition qu'elle soit sur la
 * même origine. Sinon on reconstruit depuis le chemin de la page.
 */
export function errorPageUrl(log: { url?: string | null; page?: string | null }): string {
  if (typeof window === 'undefined') return log.page || '/';
  try {
    if (log.url) {
      const parsed = new URL(log.url);
      if (parsed.origin === window.location.origin) return parsed.toString();
    }
  } catch {
    /* URL invalide : on retombe sur le chemin */
  }
  const path = log.page && log.page.startsWith('/') ? log.page : `/${log.page || ''}`;
  return `${window.location.origin}${appBase()}${path}`;
}

/** Ouvre la page en erreur dans un nouvel onglet. */
export function openErrorPage(log: { url?: string | null; page?: string | null }): void {
  const target = errorPageUrl(log);
  window.open(target, '_blank', 'noopener,noreferrer');
}